import { Suspense, useContext, useState } from "react";
import { MenuBar } from "./MenuBar";
import { IMenuItem, MenuItem, getNavigation } from "../utils/menuitems";
import { useTranslation } from "react-i18next";
import { AppContext } from "../providers/AppProvider";

export default function Index(props: any) {
  const { t } = useTranslation();
  const info = props.info;
  const app = useContext(AppContext).app;
  const locale = app.language;
  const nightMode = app.nightMode;
  const sideBars = app.sideBars;

  const getMenuItems = () => {
    const mainmenu = `welcome`;
    const aboutUs = `aboutus`;
    const aboutSite = `aboutsite`;
    const aboutOwner = `aboutowner`;
    const menuItems: IMenuItem[] = [
      new MenuItem("<<", getNavigation(mainmenu, locale, nightMode, sideBars), mainmenu),
      new MenuItem(t("menu." + aboutUs), getNavigation(aboutUs, locale, nightMode, sideBars), aboutUs),
      new MenuItem(t("menu." + aboutSite), getNavigation(aboutSite, locale, nightMode, sideBars), aboutSite),
      new MenuItem(t("menu." + aboutOwner), getNavigation(aboutOwner, locale, nightMode, sideBars), aboutOwner),
    ];
    return menuItems;
  };

  const [menu] = useState(getMenuItems());

  return (
    <MenuBar locale={locale} info={info} menuItems={menu} />
  )
}